
import OcDrawerHeader from '@marketplace/components/shared/drawer/oc-drawer-header.vue'
import { mapGetters } from 'vuex'

export default {
    name: 'OcDrawer',

    components: { OcDrawerHeader },

    props: {
        active: {
            type: Boolean,
            default: false,
        },
        alignment: {
            type: String,
            default: 'left',
            validator: function (value) {
                return ['left', 'right'].includes(value)
            },
        },
        size: {
            type: String,
            default: 'default',
            validator: function (value) {
                return ['default', 'large'].includes(value)
            },
        },
        fullWidthOnMobile: {
            type: Boolean,
            default: false,
        },
        contentClass: {
            type: String,
            default: '',
        },
        hasBottomSpacing: {
            type: Boolean,
            default: true,
        },
        isAnimatedSlideOut: {
            type: Boolean,
            default: true,
        },
        selectedPath: {
            type: String,
            default: null,
        },
    },

    computed: {
        ...mapGetters('categories', ['flatList']),
        deviceHeight() {
            return this.$store?.state?.global?.drawer?.deviceHeight || '100%'
        },
        displayedCategoryParent() {
            const currentCategory = this.flatList.find(
                (cat) => cat.path === this.selectedPath
            )

            if (!currentCategory || !currentCategory.parent_id) {
                return null
            }

            // Find the parent category based on the parent_id of the current category
            return this.flatList.find(
                (cat) => cat.id === currentCategory.parent_id
            )
        },
    },

    watch: {
        active: function () {
            if (this.active) {
                this.$nextTick(() => {
                    this.$refs.drawer.focus()
                })
            }
            setTimeout(() => {
                // we set a height to the drawer to counteract problems with browser bars and 100vh not including browser bars
                this.updateDeviceHeight()
            }, 400)
        },
    },

    activated() {
        if (this.active) {
            this.$nextTick(() => {
                this.$refs.drawer.focus()
            })
        }
    },

    mounted() {
        if (this.$breakpoint.includes('mobile')) {
            window.addEventListener('resize', this.updateDeviceHeight)
        }
    },

    deactivated() {
        if (this.$breakpoint.includes('mobile')) {
            window.removeEventListener('resize', this.updateDeviceHeight)
        }
    },

    methods: {
        closeDrawer() {
            this.$emit('close-drawer')

            document?.activeElement?.blur()
        },
        updateDeviceHeight() {
            this.$store.commit('global/updateDrawerheight', window.innerHeight)
        },
        setSelectedPath(path) {
            this.$emit('update:selectedPath', path)
        },
    },
}
